import * as React from 'react';
import { change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { compose, lifecycle, withState, withHandlers } from 'recompose';
import IconButton from 'material-ui/IconButton';
import AutoRenew from 'material-ui/svg-icons/action/autorenew';

import { Loader } from '@components/loader';
import { InputField, Input } from '@components/form';
import * as T from '@components/form/NumberSequence/_numberSequenceTypes';
import { getSequenceId, fetchSequence } from '@components/form/NumberSequence/_numberSequenceActions';
import { withNotifications } from '@components/hoc/withNotifications';

const enhance = compose<T.InnerProps, T.OutterProps>(
  withNotifications({ fetchSequence, getSequenceId }),
  connect<any, any, any>((state, { formName, inputName }) => ({
    initialValue: !!formValueSelector(formName)(state, inputName)
  })),
  withState<{}, boolean, string, string>('isFetching', 'setFetching', true),
  withState<{}, string | null, string, string>('sequenceId', 'setSequenceId', null),
  withHandlers({
    handleSequence: ({
      dispatch,
      formName,
      sequenceId,
      setSequenceId,
      sequenceKey,
      inputName,
      setFetching,
      getSequenceIdNotify,
      fetchSequenceNotify
    }) => async () => {
      setFetching(true);
      let id = sequenceId;
      if (!id) {
        id = await getSequenceIdNotify(sequenceKey);
        setSequenceId(id);
      }
      let result = '';
      if (id) {
        result = await fetchSequenceNotify(id);
      }
      dispatch(change(formName, inputName, result));
      setFetching(false);
    }
  }),
  lifecycle<any, any>({
    async componentDidMount() {
      const {
        setFetching,
        setSequenceId,
        sequenceKey,
        handleSequence,
        initialValue,
        getSequenceIdNotify,
        showButton
      } = this.props;
      setFetching(true);
      const id = await getSequenceIdNotify(sequenceKey);
      setSequenceId(id);
      if (!initialValue && !showButton) {
        await handleSequence();
      }
      setFetching(false);
    }
  })
);

const NumberSequence: React.SFC<T.OutterProps & T.InnerProps> = ({
  handleSequence,
  style,
  disabled,
  validate,
  ...props
}) => (
  <div style={{ position: 'relative', display: 'flex', alignItems: 'flex-end', ...style }}>
    {props.isFetching && <Loader />}
    <InputField
      id={props.inputName}
      name={props.inputName}
      component={Input}
      label={props.label}
      disabled={disabled}
      validate={validate}
      {...props.inputProps}
    />
    {(props.showButton || !props.initialValue) && (
      <IconButton onClick={handleSequence} disabled={disabled}>
        <AutoRenew />
      </IconButton>
    )}
  </div>
);

export default enhance(NumberSequence);



// WEBPACK FOOTER //
// ./src/components/form/NumberSequence/NumberSequence.tsx